export var website = function website(centralApi) {
  return {
    getBaseData: function getBaseData(hostname) {
      return centralApi.get('/facility/by-site-url/' + hostname);
    }
  };
};